import type {
  API,
  BlockAPI,
  BlockTune,
  ToolConfig,
} from '@editorjs/editorjs';

interface BlockTuneConstructorArgs {
  api: API;
  config?: ToolConfig;
  block: BlockAPI;
  data: unknown;
}

type GlobalMoveTuneConfig = {
  onMoveUp?: (blockId: string) => void;
  onMoveDown?: (blockId: string) => void;
};

export default class GlobalMoveTune implements BlockTune {
  private api: API;
  private blockId: string;
  private config?: GlobalMoveTuneConfig;

  constructor({ api, block, config }: BlockTuneConstructorArgs) {
    this.api = api;
    this.blockId = block.id;
    this.config = config as GlobalMoveTuneConfig;
  }

  static get isTune() {
    return true;
  }

  render() {
    const wrapper = document.createElement('div');
    wrapper.classList.add('ce-settings__global-move');

    const moveUpBtn = document.createElement('div');
    moveUpBtn.classList.add('cdx-settings-button');
    moveUpBtn.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m18 15-6-6-6 6"/>
      </svg>
    `;
    moveUpBtn.title = 'Move up';
    moveUpBtn.onclick = () => this.handleMoveUp();

    const moveDownBtn = document.createElement('div');
    moveDownBtn.classList.add('cdx-settings-button');
    moveDownBtn.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="m6 9 6 6 6-6"/>
      </svg>
    `;
    moveDownBtn.title = 'Move down';
    moveDownBtn.onclick = () => this.handleMoveDown();

    wrapper.appendChild(moveUpBtn);
    wrapper.appendChild(moveDownBtn);

    return wrapper;
  }

  static get isReadOnlySupported() {
    return true;
  }

  private handleMoveUp() {
    const currentIndex = this.api.blocks.getCurrentBlockIndex();
    if (currentIndex === 0) {
      this.config?.onMoveUp?.(this.blockId);
    } else {
      this.api.blocks.move(currentIndex - 1);
    }
  }

  private handleMoveDown() {
    const currentIndex = this.api.blocks.getCurrentBlockIndex();
    const blocksCount = this.api.blocks.getBlocksCount();
    if (currentIndex === blocksCount - 1) {
      this.config?.onMoveDown?.(this.blockId);
    } else {
      this.api.blocks.move(currentIndex + 1);
    }
  }
}
